module.exports = __webpack_public_path__ + "img/ex-5.09235f5b.svg";